import { createBrowserRouter, Navigate } from "react-router";
import { lazyLoad } from './utils/lazyLoading';

// Auth components - păstrate normale pentru încărcare rapidă
import LoginForm from './components/features/Auth/LoginForm';
import RegisterForm from './components/features/Auth/RegisterForm';
import AuthCallbackPage from './pages/AuthCallbackPage';

// Layout Components
import { AppLayout, AuthLayout, RootLayout } from './components/layout';

// Lazy loaded pages cu loading states optimizate
const DailySituationPage = lazyLoad(() => import('./pages/DailySituationPage'), {
  minDelay: 200,
  withErrorBoundary: true,
});
const TransactionsPage = lazyLoad(() => import('./pages/TransactionsPage'), {
  minDelay: 200,
  withErrorBoundary: true,
});
const LunarGridPage = lazyLoad(() => import('./pages/LunarGridPage'), {
  minDelay: 200,
  withErrorBoundary: true,
});
const OptionsPage = lazyLoad(() => import('./pages/OptionsPage'), {
  minDelay: 200,
  withErrorBoundary: true,
});
const UserProfilePage = lazyLoad(() => import('./pages/UserProfilePage'), {
  minDelay: 200,
  withErrorBoundary: true,
});

// DEVELOPMENT: Test pages (temporary)
// REMOVED: Scrollbar test page - no longer needed
// const ScrollbarTestPage = lazyLoad(() => import('./pages/ScrollbarTestPage'), {
//   minDelay: 200,
//   withErrorBoundary: true,
// });
const PerformanceTestPage = lazyLoad(() => import('./pages/PerformanceTestPage'), {
  minDelay: 200,
  withErrorBoundary: true,
});

export const createAppRouter = (isAuthenticated: boolean, onLogout: () => void) => {
  return createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      children: [{
        path: "/",
        element: isAuthenticated ? <AppLayout onLogout={onLogout} /> : <AuthLayout />,
        children: isAuthenticated ? [
        { index: true, element: <Navigate to="/daily" replace /> },
        { path: "daily", element: <DailySituationPage /> },
        { path: "transactions", element: <TransactionsPage /> },
        { path: "lunar-grid", element: <LunarGridPage /> },
        { path: "options", element: <OptionsPage /> },
        { path: "profile", element: <UserProfilePage /> },
        // DEVELOPMENT: Test routes (temporary)
        // REMOVED: Scrollbar test page - no longer needed
        // { path: "scrollbar-test", element: <ScrollbarTestPage /> },
        { path: "performance-test", element: <PerformanceTestPage /> },
        { path: "*", element: <Navigate to="/daily" replace /> }
      ] : [
        { index: true, element: <Navigate to="/login" replace /> },
        { path: "login", element: <LoginForm /> },
        { path: "register", element: <RegisterForm /> },
        { path: "auth/callback", element: <AuthCallbackPage /> },
        { path: "*", element: <Navigate to="/login" replace /> }
      ]
    }]
    }
  ]);
};